import { render, staticRenderFns } from "./ResetSubPassLogBody.vue?vue&type=template&id=03c9dfb9&scoped=true&"
import script from "./ResetSubPassLogBody.vue?vue&type=script&lang=ts&"
export * from "./ResetSubPassLogBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c9dfb9",
  null
  
)

export default component.exports